<template>
    <el-drawer
        :title="!id ? '新增页面' : '编辑SEO信息'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                v-loading="dataLoading"
            >
                <el-form-item prop="title" label="网页标题:">
                    <el-input
                        v-model="formData.title"
                        placeholder="请输入网页标题"
                        size="medium"
						:maxlength="100"
                    ></el-input>
					<small class="from-tip"><span class="el-icon-warning"></span>用户打开网页时地址栏/导航栏显示的标题</small>
                </el-form-item>
				<el-form-item prop="url" label="网址URL:">
				    <el-input
				        v-model="formData.url"
				        placeholder="请输入网址"
				        size="medium"
						:maxlength="200"
				    ></el-input>
				</el-form-item>
				<el-form-item prop="content" label="分享描述:">
				    <el-input
				        v-model="formData.content"
				        placeholder="请输入分享描述"
				        size="medium"
						:maxlength="100"
				    ></el-input>
					<small class="from-tip"><span class="el-icon-warning"></span>用户分享网页时对内容的描述</small>
				</el-form-item>
				<el-form-item prop="contentWB" label="微博描述:">
				    <el-input
				        v-model="formData.contentWB"
				        placeholder="请输入微博描述"
				        size="medium"
						:maxlength="100"
				    ></el-input>
					<small class="from-tip"><span class="el-icon-warning"></span>用户分享至微博时的发表微博的默认描述文案</small>
				</el-form-item>
				<el-form-item prop="poster" label="分享封面图URL:">
				    <el-input
				        v-model="formData.poster"
				        placeholder="请输入分享封面图"
				        size="medium"
						:maxlength="200"
				    ></el-input>
					<small class="from-tip"><span class="el-icon-warning"></span>用户分享网页时展示的图片，请填写图片的相对地址</small>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    title: "",
    url:'',
    content:'',
    contentWB:'',
	poster:''
}
export default {
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                title: [{ required: true, message: "请输入网页标题" }],
                url: [{ required: true, message: "请输入网址" }],
                content: [{ required: true, message: "请输入分享描述" }],
				contentWB: [{ required: true, message: "请输入微博描述" }],
				poster: [{ required: true, message: "请输入分享封面图" }],
            },
            id:'',
            h5List:[]            
        };
    },
    methods: {
        close() {
            this.formData = {...defaultFormData};
            this.h5List=[];
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(id) {
            this.id = id;
            if(this.id){
                this.getDataDetail();
            }
            this.drawerShow = true;
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/h5/config/info",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {                       
                        
                        this.formData = {
                            ...result                            
                        };
                        
                    } else {
                        self.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
       
        //表单提交
        submitForm() {
            let self = this;
            
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    
                    const _url = "/h5/config/save";
                    this.btnLoading = true;                    

                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
